import { useRidersForLevelRanking } from "./use-riders-for-level-ranking";
import { useRidersForUniformCoverage } from "./use-riders-for-uniform-coverage";
import { useRidersForSalaryRanking } from "./use-riders-for-salary-ranking";
import { useRidersForLoanAmount } from "./use-riders-for-loan-amount";
import { useProposalTypeData } from "../proposal/use-proposal-type-data";

export const useProposalRidersData = () => {

    const ridersForLevelRanking = useRidersForLevelRanking();
    const ridersForUniformCoverage = useRidersForUniformCoverage();
    const ridersForSalaryRanking = useRidersForSalaryRanking();
    const ridersForLoanAmount = useRidersForLoanAmount();
    const { isCoverageType, isAmountOfLoansSelected, isLevelRanking, isUniformCoverage, isSalaryRank, } = useProposalTypeData();

    if(isAmountOfLoansSelected) {
        return ridersForLoanAmount
    }

    if (!isCoverageType) return [];

    if (isLevelRanking) {
        return ridersForLevelRanking;
    }

    if (isUniformCoverage) {
        return ridersForUniformCoverage;
    }

    if (isSalaryRank) {
        return ridersForSalaryRanking;
    }

    return [];
};